import { useTranslate } from "@similarweb/i18n-provider";
import { formatDate, shortMonthDayAndYear } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { ContentRow } from "../../../common/modal/details-rows/ContentRow";
import { DetailsRow } from "../../../common/modal/details-rows/DetailsRow";
import { NewTabLinkRow } from "../../../common/modal/details-rows/NewTabLinkRow";
import type { SocialPostData } from "../types";

import { PostEngagement } from "./PostEngagement";

interface IPostDetailsSectionProps {
    post: SocialPostData;
}

export const PostDetailsSection = ({ post }: IPostDetailsSectionProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="16px"
            minWidth={0}
        >
            <Text
                fontVariant="h5_2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("activation.alerts.cards.social-post.modal.post-details")}
            </Text>

            <Stack gap="16px">
                <ContentRow content={post.content} />

                <DetailsRow label={translate("activation.alerts.cards.social-post.modal.creative-type")}>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                        textTransform="capitalize"
                    >
                        {post.mediaType}
                    </Text>
                </DetailsRow>

                <DetailsRow label={translate("activation.alerts.cards.social-post.modal.publish-date")}>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {formatDate(post.publishedDate, undefined, shortMonthDayAndYear)}
                    </Text>
                </DetailsRow>

                <DetailsRow label={translate("activation.alerts.cards.social-post.modal.engagement")}>
                    <PostEngagement
                        reactions={post.reactions}
                        comments={post.comments}
                        shares={post.shares}
                        views={post.mediaType === "Video" ? post.views : undefined}
                    />
                </DetailsRow>

                {post.postUrl ? (
                    <NewTabLinkRow
                        label={translate("activation.alerts.cards.social-post.modal.view-post")}
                        url={post.postUrl}
                    />
                ) : null}
            </Stack>
        </Stack>
    );
};
